import type { ComponentProps } from 'react'

import {
  ICON_DEFAULT_COLOR,
  ICON_DEFAULT_FILL,
  ICON_DEFAULT_HEIGHT,
  ICON_DEFAULT_VIEWBOX,
  ICON_DEFAULT_WIDTH,
  type IconProps,
} from 'components'

export const HomeRounded = ({
  color = ICON_DEFAULT_COLOR,
  fill = ICON_DEFAULT_FILL,
  width = ICON_DEFAULT_WIDTH,
  height = ICON_DEFAULT_HEIGHT,
  viewBox = ICON_DEFAULT_VIEWBOX,
  ...props
}: ComponentProps<'svg'> & Omit<IconProps, 'icon'>) => {
  return (
    <svg
      fill={fill}
      height={height}
      viewBox={viewBox}
      width={width}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M 29.6875 27.082031 C 29.6875 26.945312 29.632812 26.8125 29.535156 26.714844 C 29.4375 26.617188 29.304688 26.5625 29.167969 26.5625 L 20.832031 26.5625 C 20.695312 26.5625 20.5625 26.617188 20.464844 26.714844 C 20.367188 26.8125 20.3125 26.945312 20.3125 27.082031 L 20.3125 42.1875 L 29.6875 42.1875 Z M 45.3125 39.582031 C 45.3125 41.101562 44.707031 42.558594 43.632812 43.632812 C 42.558594 44.710938 41.101562 45.3125 39.582031 45.3125 L 10.417969 45.3125 C 8.898438 45.3125 7.441406 44.710938 6.367188 43.632812 C 5.292969 42.558594 4.6875 41.101562 4.6875 39.582031 L 4.6875 20.832031 C 4.6875 20 4.871094 19.175781 5.21875 18.421875 C 5.527344 17.757812 5.957031 17.164062 6.484375 16.664062 L 6.71875 16.457031 L 21.292969 3.964844 L 21.300781 3.957031 L 21.703125 3.648438 C 22.664062 2.972656 23.816406 2.605469 25 2.605469 C 26.183594 2.605469 27.335938 2.972656 28.296875 3.648438 L 28.699219 3.957031 L 28.707031 3.964844 L 43.28125 16.457031 C 43.917969 16.992188 44.429688 17.664062 44.78125 18.421875 C 45.128906 19.175781 45.3125 20 45.3125 20.832031 Z M 32.8125 42.1875 L 39.582031 42.1875 C 40.273438 42.1875 40.9375 41.914062 41.425781 41.425781 C 41.914062 40.9375 42.1875 40.273438 42.1875 39.582031 L 42.1875 20.832031 L 42.171875 20.550781 C 42.140625 20.269531 42.066406 19.992188 41.945312 19.734375 C 41.785156 19.390625 41.554688 19.085938 41.265625 18.84375 L 41.253906 18.835938 L 26.671875 6.339844 L 26.671875 6.335938 C 26.203125 5.945312 25.609375 5.730469 25 5.730469 C 24.386719 5.730469 23.792969 5.945312 23.324219 6.335938 L 23.328125 6.339844 L 8.746094 18.835938 L 8.734375 18.84375 C 8.445312 19.085938 8.214844 19.390625 8.054688 19.734375 C 7.894531 20.078125 7.8125 20.453125 7.8125 20.832031 L 7.8125 39.582031 C 7.8125 40.273438 8.085938 40.9375 8.574219 41.425781 C 9.0625 41.914062 9.726562 42.1875 10.417969 42.1875 L 17.1875 42.1875 L 17.1875 27.082031 C 17.1875 26.117188 17.570312 25.1875 18.253906 24.503906 C 18.9375 23.820312 19.867188 23.4375 20.832031 23.4375 L 29.167969 23.4375 C 30.132812 23.4375 31.0625 23.820312 31.746094 24.503906 C 32.429688 25.1875 32.8125 26.117188 32.8125 27.082031 Z M 32.8125 42.1875 "
        fill={color}
      />
    </svg>
  )
}
